import { j as m } from "../../../../jsx-runtime-B6kdoens.js";
import { a as t } from "../../../../index-CROKJrb5.js";
import { c as s, f as e } from "../../../../create-component-CBAeEoQ6.js";
import { CardImage as n } from "../../CardImage/index.js";
const C = s(
  "ControlCardImage",
  e(
    ({ className: r, ...o }, a) => /* @__PURE__ */ m.jsx(
      n,
      {
        ref: a,
        className: t("cur-w-1/4 cur-shrink", r),
        ...o
      }
    )
  )
);
export {
  C as ControlCardImage
};
//# sourceMappingURL=index.js.map
